import React, { useState } from 'react';
import { Play, Camera } from 'lucide-react';

// Import foto-foto Anda
import galeri1 from '../assets/kamar-utama.jpeg';
import galeri2 from '../assets/ruang-tamu.jpeg';
import galeri3 from '../assets/dapur.jpeg';
import galeri4 from '../assets/kolam-renang.jpeg';
import galeri5 from '../assets/kamar-mandi.jpeg';
import galeri6 from '../assets/teras.jpeg';
import galeri7 from '../assets/kamar3-1.jpeg';
import galeri8 from '../assets/kamar3-2.jpeg';
import view1 from '../assets/sawah.jpeg';
import view2 from '../assets/kebun.jpg';
import galeri9 from '../assets/kolam.jpg';
import galeri10 from '../assets/view1.jpg';

const Gallery = () => {
  const [filter, setFilter] = useState('all');

  const photos = [
    { id: 1, src: galeri1, title: 'Kamar Tidur LT 2', category: 'interior' },
    { id: 2, src: galeri2, title: 'Ruang Tamu Open Space', category: 'interior' },
    { id: 3, src: galeri3, title: 'Dapur', category: 'dining' },
    { id: 4, src: galeri4, title: 'Kolam Renang', category: 'exterior' },
    { id: 5, src: galeri5, title: 'Kamar Mandi LT 1', category: 'interior' },
    { id: 6, src: galeri6, title: 'Halaman Depan', category: 'exterior' },
    { id: 7, src: galeri7, title: 'Kamar Tidur 2 LT 3', category: 'interior' },
    { id: 8, src: galeri8, title: 'Kamar Tidur 1 LT 3', category: 'interior' },
    { id: 9, src: view1, title: 'Pemandangan Sawah Malino', category: 'view' },
    { id: 10, src: view2, title: 'Pemandangan Kebun', category: 'view' },
    { id: 11, src: galeri9, title: 'Pemandangan Kabut', category: 'view' },
    { id: 12, src: galeri10, title: 'Pemandangan Sunset', category: 'view' },
  ];

  const filteredPhotos = filter === 'all' 
    ? photos 
    : photos.filter(p => p.category === filter);

  return (
    <div className="bg-white min-h-screen font-poppins pt-10 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        
        {/* Header Halaman */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-gray-900 mb-4">
            Galeri <span className="text-red-600">Visual</span>
          </h1>
          <p className="text-gray-500 max-w-2xl mx-auto uppercase tracking-[0.3em] text-xs md:text-sm">
            Melihat lebih dekat fasilitas Villa Ballaeja
          </p>
          <div className="w-20 h-1 bg-red-600 mx-auto mt-6"></div>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {['all', 'interior', 'exterior', 'dining', 'view'].map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-8 py-2 text-xs font-bold tracking-widest uppercase transition-all border
                ${filter === cat 
                  ? 'bg-red-600 border-red-600 text-white' 
                  : 'bg-transparent border-gray-200 text-gray-400 hover:border-red-600 hover:text-red-600'
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid Galeri */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPhotos.map((photo) => (
            <div key={photo.id} className="group relative overflow-hidden bg-gray-100 aspect-[4/3]">
              <img 
                src={photo.src} 
                alt={photo.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center items-center text-white">
                <Camera className="mb-2" size={24} />
                <p className="font-bold tracking-widest uppercase text-sm">{photo.title}</p>
              </div>
            </div>
          ))}

          <div className="relative overflow-hidden bg-gray-900 aspect-[4/3] flex flex-col justify-center items-center text-center p-8">
            <div className="w-16 h-16 bg-red-600 rounded-full flex justify-center items-center mb-4 animate-pulse shadow-lg shadow-red-600/40 cursor-pointer hover:scale-110 transition-transform">
              <Play fill="white" size={24} />
            </div>
            <h3 className="text-white font-bold tracking-widest uppercase mb-2">Cinema Tour</h3>
            <p className="text-gray-400 text-xs italic">Lihat suasana villa secara nyata melalui video tour 30 detik kami.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Gallery;